import React from "react";
import { observer } from "mobx-react-lite";

import { editMediaStore } from "../../edit-media.store";
import { AdjustmentsFilters } from "./adjustments-filters";
import { BrushTools } from "./brush-tools";
import { Crop } from "./crop";

export const Adjustments: React.FC = observer(() => {
  const { isInCrop } = editMediaStore;

  if (isInCrop) {
    return (
      <>
        <Crop />
      </>
    );
  }

  return (
    <>
      <AdjustmentsFilters />
      <BrushTools />
      <Crop />
    </>
  );
});

export default Adjustments;
